// src/App.jsx
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import './App.css'
import { PermissionProvider } from "./context/PermissionContext";
import { ExportProvider } from "./context/ExportContext";
import AnalyticsWrapper from "./hooks/useAnalytics";
import BoardPackExportHost from "./components/BoardPack/BoardPackExportHost";
import ExportOverlay from "./components/BoardPack/ExportOverlay";
import ReportJobsWatcher from "./components/BoardPack/ReportJobsWatcher";

export default function App() {
  return (
    <BrowserRouter>
      <PermissionProvider>
        <ExportProvider>
          <AnalyticsWrapper />
          <AppRoutes />
          <BoardPackExportHost />
          <ExportOverlay />
          <ReportJobsWatcher />
        </ExportProvider>
      </PermissionProvider>
    </BrowserRouter>
  );
}
